/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');
var AuditLogView = require('common/views/AuditLogView');

var GetAuditLog = require('../services/GetAuditLog');

module.exports = {
  channel: 'cs',

  event: 'build:audit-log-view',

  builder: function(complaintId) {
    return new PlaceholderView({
      viewPromise: buildAuditLogView(complaintId)
    });
  }
};

function buildAuditLogView(complaintId) {
  var deferred = $.Deferred();
  GetAuditLog(complaintId)
    .done(function(auditLog) {
      deferred.resolve(
        new AuditLogView({
          model: new Backbone.Model({
            objectId: complaintId
          }),
          collection: new PageableCollection(auditLog, { pageSize: 10 })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
